import React from 'react';
import CgTable from 'modules/Common/table';
import { DATE_FORMAT, formatDateTime } from 'helpers/dateParser';
import { ERP_SYSTEM_NAMES } from 'modules/Common/config/erpSystems';

/**
 * The individual ERP integration requests behind the demand bars — who asked, for
 * what, and how to reach them. Canonical Table (D12); state comes from useCgTable
 * as `tableProps`.
 */

const HOSTING_LABELS = { cloud: 'Cloud', on_premise: 'On-premise' };

const erpCell = (request) =>
  request.erpSystem === 'other'
    ? `Other: ${request.erpSystemOther ?? '—'}`
    : ERP_SYSTEM_NAMES[request.erpSystem];

export const ERP_REQUEST_HEADERS = [
  { label: 'Organization', key: 'organization', noCopyButton: true },
  { label: 'ERP', key: 'erp', noCopyButton: true },
  { label: 'Hosting', key: 'hosting', noCopyButton: true },
  { label: 'Sync', key: 'sync', noCopyButton: true },
  { label: 'Contact', key: 'contact' },
  { label: 'Note', key: 'note', noCopyButton: true },
  { label: 'Requested', key: 'requested', noCopyButton: true },
];

/** Maps 1:1 and never filters or reorders (useCgTable D6). */
export const mapErpRequestRow = (request) => ({
  organization: (
    <span className="font-medium text-slate-900">{request.organizationName ?? '—'}</span>
  ),
  erp: (
    <div className="min-w-0">
      <div className="truncate">{erpCell(request)}</div>
      {request.version ? (
        <div className="truncate text-xs text-slate-500">{request.version}</div>
      ) : null}
    </div>
  ),
  hosting: HOSTING_LABELS[request.hosting] ?? request.hosting,
  sync: request.dataToSync?.join(', ') || '—',
  contact: [request.contactName, request.contactEmail].filter(Boolean).join(' · ') || '—',
  note: (
    <span
      className="line-clamp-2 text-sm text-slate-600"
      title={request.note}
    >
      {request.note || '—'}
    </span>
  ),
  requested: formatDateTime(request.createdAt, DATE_FORMAT.MEDIUM),
});

export default function ErpRequestsTable({ tableProps }) {
  return (
    <CgTable
      {...tableProps}
      emptyStateTitle="No ERP integration requests yet"
      emptyStateDescription="Requests appear here when a declarant submits one."
    />
  );
}
